import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'buyer-review-section',
    template: `
        <card [headerTitle]="sectionTitle" [style.display]="'block'" [style.marginBottom]="'3rem'">
            <div right-header-content>
                <lsq-button appearance="transparent" (buttonClick)="navigate()">
                    <a>Edit</a>
                </lsq-button>
            </div>
            <div card-body>
                <ng-content></ng-content>
            </div>
        </card>
    `
})
export class BuyerReviewSectionComponent {
    @Input() public sectionTitle: string;
    @Input() public editLocation: string;

    constructor(private _router: Router) {}

    public navigate() {
        this._router.navigateByUrl(this.editLocation);
    }
}
